import { filter, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { Logger } from 'html2canvas/dist/types/core/logger';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { ConfigService } from 'src/app/services/config.service';
import { VedioLinksService } from 'src/app/services/vedio-links.service';
import { Subject } from 'rxjs';
import { StepGuideService } from 'src/app/services/step-guide.service';
import { contains } from 'jquery';
import { contacts } from 'src/app/data/mock/apps/contacts/data';
import { Constant } from 'src/app/constant/constant';
import { GuideService, GuideStep } from 'src/app/services/guide.service';

@Component({
  selector: 'calsoft-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  sanitizedUrl: string = '';

  currentPath = '';

  @Input() url: string;
  @Input() currentPage: string;
  @Input() names: string[] = [];
  @Input() routes: string[] = [];
  @Input() header;

  @Input() newTitle;

  public breadcrumbs: {
    name: string;
    url: string
  }[] = [];
  configData: any;

  public youtubeUrl = 'https://www.youtube.com/embed/';

  GridType: any = 1;
  enableDemoVideoLinks: any = 1;
  tour: any;


  constructor(
    private configService: ConfigService,
    public router: Router,
    private ecryptService: EcryptServiceService,
    private sanitizer: DomSanitizer,
    private vedioLinksService: VedioLinksService,
    private stepGuideService: StepGuideService,
    public guideService: GuideService,

  ) {
    this.currentPath = this.router.url || '';
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  showHint = true;

  showVideoModal = false;
  videoId: any



  ngOnInit() {


    this.getBreadcrumbsPath();
    setTimeout(() => {
      this.showHint = false;
    }, 10000);

    let breadcrumbtype = localStorage.getItem('adminBreadcrumbType');

    const encryptedConfig = localStorage.getItem('configSettingsData')


    if (encryptedConfig) {
      const decrypted = this.ecryptService.decryptionAES(encryptedConfig);

      this.configData = JSON.parse(decrypted);

      if (this.configData['adminBreadcrumbType'] != undefined) {

        this.breadcrumbtype = this.configData['adminBreadcrumbType'];

      }

      this.GridType = this.configData.gridType;

      if (this.configData['enableDemoVideoLinks'] != undefined) {

        this.enableDemoVideoLinks = this.configData['enableDemoVideoLinks'];

      } else {
        this.enableDemoVideoLinks = 1
      }


    }

    this.getVideo();
  }

  getVideo() {

    const nameToSearch = this.breadcrumbsName?.toLowerCase().replace(/\s+/g, '');

    console.log("nameToSearch", nameToSearch);

    const model = Constant.DEVICE_MODEL || 1;

    if (nameToSearch) {
      this.stepGuideService.getPlansAndDeviceType(nameToSearch, model).subscribe(
        res => {
          if (res != null) {
            this.tour = res;
            let id = res['videoId'] || res['videoLink'];
            if (id != null || id != undefined || id != '') {
              this.videoId = this.extractId(id);
            }
          } else {
            this.getVideoTwo();
          }
        },
        error => {
          console.error('Failed to fetch video links', error);
        }
      );
    }
  }




  getVideoTwo() {

    const nameToSearch = this.breadcrumbsName.toLowerCase();

    if (nameToSearch && nameToSearch.trim() !== '') {

      this.vedioLinksService.getVedioLinksByName(nameToSearch).subscribe(
        res => {

          if (res != null) {
            this.videoId = res['videoId'];
          }

        },
        error => {
          console.error('Failed to fetch video links', error);
        }
      );
    }


  }


  breadcrumbsName: any;



  getBreadcrumbsPath() {
    let a = this.currentPage.split(",")
    let b = this.currentPath.split(",")
    for (var i = 0; i < a.length; i++) {
      this.breadcrumbs.push({
        name: a[i],
        url: '/' + b[i]
      })


    }


    let length = this.breadcrumbs.length - 1;
    this.currentPage = this.breadcrumbs[length].name;

    this.breadcrumbsName = this.breadcrumbs[this.breadcrumbs.length - 1].name;

  }
  data: Object;

  breadcrumbtype: any;


  openVideoModal() {
    this.getVideo();
    this.showVideoModal = true;
    document.body.style.overflow = 'hidden';
  }


  extractId(url: string): string {
    if (!url) return '';
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : url;
  }

  closeVideoModal() {
    this.showVideoModal = false;
    document.body.style.overflow = 'auto';
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  startTour() {

    const steps: GuideStep[] = (this.tour.stepGuideSteps || [])
      .sort((a: any, b: any) => a.stepOrder - b.stepOrder)
      .map((s: any): GuideStep => ({
        id: s.stepKey,
        text: s.text,
        route: s.route,
        action: s.action,
        overlayContext: s.overlayContext,
        manual: s.manual === 1,
        guideId: s.guideId ? s.guideId.toString() : null,
        guideKey: s.guideKey ? s.guideKey.toString() : null,
        selector: s.selector,
        matchIndex: s.matchIndex,
        description: s.stepSescription,
        imageUrl: s.imageUrl,
        imageLinkUrl: s.imageLinkUrl,
        customfield1: s.customfield1,
        customfield3: s.customfield3,
        videoLink: s.videoLink,
      }));

    if (steps) {
      (steps as any).deviceType = this.tour.deviceType;
    }
    this.guideService.start(steps, [], this.tour.videoLink);
  }


}
